import React from 'react';
import ReactGA from "react-ga4";
import { NavLink } from "react-router-dom";
import '../style/components/_footer.scss'

const Footer = () => {
    const handleLinkClickInstagram = () => {
        ReactGA.event({
            category: "User Interaction",
            action: "Clicked Link Instagram (footer)",
        })
    }

    const handleLinkClickFacebook = () => {
        ReactGA.event({
            category: "User Interaction",
            action: "Clicked Link Facebook (footer)",
        })
    }

    const handleLinkClickLinkedin = () => {
        ReactGA.event({
            category: "User Interaction",
            action: "Clicked Link LinkedIn (footer)",
        })
    }

    return (
        <footer className="footer">
            <div className="main-container">

                <div className="menu-container">
                    <NavLink to="/" activeClassName="active"><h4>O3 Académie</h4>
                    </NavLink>
                    <ul><li><NavLink to="/nos-formations" activeClassName="active" aria-label="Redirection vers Nos Formations"><h4>Nos Formations</h4>
                    </NavLink></li>
                        <li>
                            <NavLink to="/conseiller-numerique" activeClassName="active" aria-label="Redirection vers Conseiller numérique">
                                Conseiller numérique
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/responsable-espaces-mediation-numerique" activeClassName="active" aria-label="Redirection vers Responsable d'espaces de médiation numérique">
                                Responsable d'Espaces de Médiation Numérique
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/facilitateur-de-tiers-lieu" activeClassName="active" aria-label="Redirection vers Facilitateur de tiers-lieu">
                                Facilitateur de Tiers-lieu
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/piloter-un-tiers-lieu" activeClassName="active" aria-label="Redirection vers Piloter un tiers-lieu">
                                Piloter un Tiers-lieu
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/testeur-logiciel" activeClassName="active" aria-label="Redirection vers Testeur logiciel">
                                Testeur Logiciel
                            </NavLink>
                        </li>
                    </ul>
                    <NavLink to="/certification-qualiopi" activeClassName="active">
                        <h4>Certification Qualiopi</h4>
                    </NavLink>
                    <NavLink to="/contact" activeClassName="active">
                        <h4>Nous contacter</h4>
                    </NavLink>
                </div>

                <div className="socials-container">
                    <h4>Suivez-nous !</h4>
                    <ul className="socials-list">

                        <li className="socials-item">
                            <a href="https://www.instagram.com/o3entrepriseadaptee/?hl=fr" onClick={handleLinkClickInstagram} className="socials-link" target="_blank" rel="noopener noreferrer" aria-label="Redirection vers notre Instagram">
                                <svg role="img" aria-label="Instagram" className="socials-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69" tabIndex="0">
                                    <g id="wc44M4">
                                        <g>
                                            <path d="M13.3,2.03l30.01-.02c.11.01.21.08.32.09,6.03.65,10.5,5.35,11.06,11.37v29.74c-.49,6.09-5.37,10.98-11.47,11.47H13.48c-6.09-.49-10.99-5.36-11.47-11.47V13.58C2.42,7.52,7.26,2.57,13.3,2.03ZM13.51,6.15c-3.9.45-6.95,3.54-7.38,7.44v29.42c.39,4.02,3.54,7.16,7.55,7.56h29.33c4.02-.4,7.16-3.54,7.56-7.56V13.68c-.4-4.02-3.54-7.16-7.56-7.56l-29.5.03Z" />
                                            <path d="M26.88,15.1c7.3-.66,13.38,3.8,14.63,11.04,1.93,11.18-10.22,19.49-19.98,13.71-10.92-6.47-7.39-23.6,5.36-24.75ZM27.5,19.11c-6.85.62-10.54,8.2-7.05,14.1,3.42,5.8,12.46,5.76,15.84-.07,3.82-6.56-1.23-14.72-8.79-14.04Z" />
                                            <path d="M42.41,11.29c3.44-.58,4.16,4.67.8,5.12-3.32.44-4.07-4.57-.8-5.12Z" />
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </li>

                        <li className="socials-item">
                            <a href="https://www.facebook.com/O3ExpertsEA/?locale=fr_FR" onClick={handleLinkClickFacebook} className="socials-link" target="_blank" rel="noopener noreferrer" aria-label="Redirection vers notre Facebook">
                                <svg role="img" aria-label="Facebook" className="socials-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69" tabIndex="0">
                                    <path d="M54.68,46.9c0-.12,0-.23,0-.34V9.48c-.45-3.98-3.66-7.14-7.66-7.47H9.67c-4.06.32-7.34,3.6-7.66,7.66v37.45c.39,3.99,3.57,7.18,7.56,7.56h37.65c2.43-.3,4.55-1.53,5.97-3.51.69-.96,1.3-2.43,1.47-3.78.01-.06.03-.11.04-.17v-.33ZM46.91,50.57h-11.26v-17.9h4.99s.46-.15.54-.18c1.54-.69,1.54-3.06,0-3.75-.08-.03-.51-.18-.54-.18h-4.99v-6.12c0-.15.26-.91.33-1.11.53-1.39,1.95-2.39,3.43-2.54.97-.1,1.88.23,2.71-.48,1.36-1.15.7-3.44-1.08-3.64-4.62-.52-8.79,2.53-9.41,7.14-.01.11-.1.2-.1.21v6.53h-4.99s-.46.15-.54.18c-1.54.69-1.54,3.06,0,3.75.07.03.51.18.54.18h4.99v17.9H9.77c-.15,0-.91-.26-1.11-.33-1.49-.57-2.35-1.97-2.55-3.52V9.98c.23-2.12,1.74-3.63,3.86-3.86h36.73c2.12.23,3.63,1.74,3.86,3.86v36.44c-.03.32-.05.65-.13.99-.39,1.64-1.84,2.96-3.52,3.16Z" fill="#9A3740;" />
                                </svg>
                            </a>
                        </li>

                        <li className="socials-item">
                            <a href="https://www.linkedin.com/company/o3-experts-entreprise-adapt%C3%A9e/" onClick={handleLinkClickLinkedin} className="socials-link" target="_blank" rel="noopener noreferrer" aria-label="Redirection vers notre Linkedin">
                                <svg role="img" aria-label="LinkedIn" className="socials-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.69 56.69" tabIndex="0">
                                    <g id="_8Xv7MK" data-name="8Xv7MK">
                                        <g>
                                            <path d="M7.57,2.2l41.38-.03c2.95.35,5.22,2.62,5.57,5.57v41.2c-.35,2.95-2.62,5.22-5.57,5.57H7.74c-2.95-.35-5.22-2.62-5.57-5.57V7.74c.34-2.88,2.52-5.14,5.4-5.54ZM7.98,6.29c-.96.16-1.62.9-1.71,1.86v40.38c.1,1,.74,1.66,1.71,1.87l40.57.02c1-.14,1.65-.72,1.87-1.71l.02-40.57c-.14-1.04-.83-1.78-1.89-1.89l-40.56.03Z" />
                                            <path d="M33.13,22.34c5.9-.59,10.7,3.38,11.28,9.22.41,4.16-.11,8.67.1,12.89-.22,2.42-3.35,2.76-4.07.49l-.02-12.76c-.66-7.67-11.4-7.68-12.07,0l-.02,12.76c-.72,2.27-3.85,1.94-4.07-.49.2-4.09-.25-8.41,0-12.48.29-4.79,3.97-9.14,8.87-9.63Z" />
                                            <path d="M13.8,22.34c1.23-.21,2.25.44,2.49,1.66v20.76c-.51,2.42-3.87,2.22-4.1-.31v-20.14c.09-.89.67-1.81,1.61-1.97Z" />
                                            <path d="M13.9,14.26c.75-.13,1.57.18,2.02.8.66.93.45,2.32-.52,2.95-1.6,1.04-3.67-.55-3.08-2.36.21-.63.92-1.27,1.58-1.38Z" />
                                        </g>
                                    </g>
                                </svg>
                            </a>
                        </li>

                    </ul>
                </div>

                <div className="qualiopi-container">
                    <img className="qualiopi-logo" src="../../assets/img/logo-qualiopi.jpg" alt="Certification Qualiopi" />
                    <p>La certification de qualité a été délivrée au titre des catégories d'action suivantes :
                        <ul>
                            <li>ACTIONS DE FORMATION</li>
                            <li>ACTIONS DE FORMATION PAR APPRENTISSAGE</li>
                        </ul>
                        <a href="/Certificat_F3350.pdf" className="qualiopi-link" target="_blank" rel="noopener noreferrer">Voir le certificat</a>
                    </p>
                </div>

                <div className="logo-container">
                    <NavLink to="/">
                        <img className="logo" src="../assets/img/logo.png" alt="Accueil" />
                    </NavLink>
                </div>

            </div>

            <div className="legals-container">
                <ul>
                    <li>
                        <NavLink to="/politique-de-confidentialite" activeClassName="active">
                            Politique de confidentialité
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/mentions-legales" activeClassName="active">
                            Mentions légales
                        </NavLink>
                    </li>
                    <li><a href="/CGV.pdf" target="_blank" rel="noopener noreferrer">CGV</a></li>
                    <li>© 2024</li>
                    <li>O3 Académie</li>
                </ul>
            </div>

        </footer>
    );
};

export default Footer;